export const featureFlags = {
  versionWarningNotification: true
}
